export default __webpack_public_path__ + "static/media/markerAndBeaconT.856024a0.svg";